import React, { Component } from "react"

import Title from "../../components/global/Title/Title"
import Button from "../../components/global/Button/Button"

export default class ANBI extends Component {
  render() {
    const { acf } = this.props.data;
    
    const anbi = acf && acf.anbi

    return(
      <section className="">
        <div className="max-w-screen-md mx-auto">
          <div className="flex flex-col justify-center gap-4 text-center">
            <Title level="2">{anbi ? anbi.title : ''}</Title>
            <div className={`page-content text-xs md:text-sm lg:text-base text-gray-500 leading-loose`} dangerouslySetInnerHTML={{__html: anbi ? anbi.content : ''}}/>
            <div>
              { anbi && anbi.button && (
                <a href={anbi.button.url ?? '#'} target={anbi.button.target ?? '_self'} className={`px-6 py-3 inline-block rounded-lg bg-orange text-white text-sm md:text-base lg:text-md hover:bg-darkorange ease-in-out duration-300 focus:outline-none`}>{anbi.button.title}</a>
              )}
              </div>
          </div>
        </div>
      </section>
    );
  }
}
